import { useEffect } from 'react';
import { useProgress } from '../hooks/useProgress';
import { useAuth } from '../hooks/useAuth';

interface LessonProgressTrackerProps {
  lessonId: string;
  lessonTitle: string;
  grade: string;
}

export default function LessonProgressTracker({ lessonId, lessonTitle, grade }: LessonProgressTrackerProps) {
  const { markComplete, isCompleted } = useProgress();
  const { profile } = useAuth();
  const isActive = profile?.membership_status === 'ACTIVE';
  const completed = isCompleted(lessonId);

  // Auto-mark as visited when component mounts (for active members only)
  useEffect(() => {
    if (isActive && !completed) {
      // Mark as complete after 3 seconds of viewing
      const timer = setTimeout(() => {
        markComplete(lessonId, lessonTitle, grade);
      }, 3000);

      return () => clearTimeout(timer);
    }
  }, [isActive, completed, lessonId, lessonTitle, grade, markComplete]);

  if (!isActive) return null;

  return (
    <div className="fixed bottom-6 right-6 z-40">
      {completed ? (
        <div className="bg-green-500 text-white px-4 py-3 rounded-lg shadow-lg flex items-center gap-2 animate-fade-in">
          <i className="ri-checkbox-circle-fill text-xl"></i>
          <span className="font-medium text-sm">Lesson Completed!</span>
        </div>
      ) : (
        <button
          onClick={() => markComplete(lessonId, lessonTitle, grade)}
          className="bg-white border-2 border-teal-500 text-teal-600 px-4 py-3 rounded-lg shadow-lg hover:bg-teal-50 transition-all flex items-center gap-2 font-medium text-sm whitespace-nowrap"
        >
          <i className="ri-checkbox-line text-xl"></i>
          Mark as Complete
        </button>
      )}
    </div>
  );
}